import React from "react";
import { ListGroup } from "react-bootstrap";

export default function SavedPayees({ payees, onClick }) {
  return (
    <span className="payeeslist">
      <ListGroup>
        {payees.map((x, index) => {
          const name = x.details["Beneficiary Name"];
          const icon = name.match(/\b\w/g).join("").substring(0, 2).toUpperCase();
          return (
          
            <ListGroup.Item key={index} onClick={() => onClick(x)}>
              <div className="payeeicon"><div className="content">{icon}</div></div>
              {name}
            </ListGroup.Item>
          
          );
        })}
      </ListGroup>
    </span>
  );
}
